import apiClient from './apiClient';

export async function fetchPrioritizedAlerts() {
  const { data } = await apiClient.get('/ai/alerts/prioritized');
  return data.map((a) => ({
    id: a.id, title: a.summary, aiScore: Math.round(a.priority_score),
    severity: String(a.original_severity).toLowerCase(),
    suggestedAction: `Priority ${a.priority_rank} · ${a.source_module}`,
    timestamp: a.created_at
  }));
}

export async function fetchAnomalyTimeline() {
  const { data } = await apiClient.get('/ai/anomaly-timeline');
  return data;
}

export async function fetchThreatPredictions() {
  const { data } = await apiClient.get('/ai/predictions');
  return [{
    id: `prediction-${data.entity}`, title: data.summary,
    confidence: Math.round(Number(data.confidence) <= 1 ? Number(data.confidence) * 100 : Number(data.confidence)),
    window: 'Next analysis window',
    basis: `${data.direction} trend from ${data.window_counts.length} historical windows`
  }];
}

export async function fetchBehavioralInsights() {
  const { data } = await apiClient.get('/ai/behavioral-insights');
  return data;
}
